import { useMutation, useQuery } from "@tanstack/react-query";
import FETCHER from "./_fetcher";

interface AcceptanceConditionResponse {
  needsAcceptance: {
    needsAcceptance: boolean;
    isFirst: boolean;
  };
}

export const useCheckAcceptanceCondition = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["acceptance-condition"],
    queryFn: async () => {
      const response = await FETCHER.get<AcceptanceConditionResponse>(
        "/acceptance-condition/check"
      );
      return response.data;
    },
    enabled: false, // Don't fetch automatically
  });

  return {
    acceptanceCondition: data?.needsAcceptance,
    isLoading,
    error,
    checkAcceptanceConditionAsync: refetch,
  };
};

export const useAcceptCondition = () => {
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: async () => {
      const response = await FETCHER.post("/acceptance-condition/accept");
      return response.data;
    },
  });

  return {
    acceptConditionAsync: mutateAsync,
    isPending,
    error,
  };
};
